import styled from 'styled-components';
import { media } from '../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.lg};
  width: 100%;
`;

export const SoDesktop = styled.div`
  ${media.mobile} {
    display: none;
  }
`;

export const FichaMobileContainer = styled.div`
  display: none;

  ${media.mobile} {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.espaco.sm};
  }
`;

export const FichaMobile = styled.button`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${({ theme }) => theme.espaco.sm} ${({ theme }) => theme.espaco.md};
  width: 100%;
  padding: ${({ theme }) => theme.espaco.md} ${({ theme }) => theme.espaco.lg};
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.card};
  background-color: ${({ theme }) => theme.cores.card};
  box-shadow: ${({ theme }) => theme.sombra.card};
  text-align: left;

  &:active {
    background-color: ${({ theme }) => theme.cores.surface};
  }

  /* O primeiro campo (normalmente o principal) ocupa a linha toda */
  > div:first-child {
    grid-column: 1 / -1;

    strong {
      font-size: ${({ theme }) => theme.fonte.h3};
    }
  }
`;

export const CampoFicha = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;

  small {
    color: ${({ theme }) => theme.cores.inkMuted};
    font-size: ${({ theme }) => theme.fonte.caption};
  }

  strong {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.cores.ink};
    font-weight: 500;
  }
`;
